import { StarsBackground } from '@/components/animate-ui/components/backgrounds/stars';

export default function SiteBackground() {
  return (
    <StarsBackground
      starColor="#1f7a34"
      className="fixed inset-0 -z-10 bg-[radial-gradient(ellipse_at_bottom,_#fff9e8_0%,_#fffefb_48%,_#ffffff_100%)]"
    />
  );
}
